var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styleName),attrs:{"name":"tinymce"}},[_c('div',{staticClass:"tinymce-container editor-container",class:{ fullscreen: _vm.fullscreen }},[_c('div',{staticClass:"tinymce-textarea",attrs:{"id":_vm.tinymceId}})])])}
var staticRenderFns = []

export { render, staticRenderFns }